import React from "react";
import { Button, Divider } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import {
  ContainerMenu,
  ImgCity,
  ListMenu,
  SubMenu,
  TitleMenu,
} from "./styled.components";
import { useDispatch, useSelector } from "react-redux";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { useNavigate } from "react-router-dom";

//ts-ignore
const MenuClientes = () => {
  const dispatch = useDispatch();
  const navigation = useNavigate();

  const { viewSondeo } = useSelector((state: any) => state.common);

  const HandleClick = (vista: number) => {
    dispatch({
      type: "SET_VIEWSONDEO",
      data: vista,
    });
  };

  return (
    <ContainerMenu>
      <SubMenu>
        <TitleMenu>
          <Button
            variant="outlined"
            startIcon={<ArrowBackIosNewIcon />}
            onClick={() => {
              navigation && navigation("../clientes/mapa");
            }}
          >
            Mapa
          </Button>
          <span>Sondeos</span>
        </TitleMenu>
        <ListMenu selected={viewSondeo}>
          <div onClick={() => HandleClick(1)}>
            <p>Ejecución</p>
            <span
              children={
                viewSondeo === 1 ? (
                  <KeyboardArrowRightIcon />
                ) : (
                  <KeyboardArrowLeftIcon />
                )
              }
            />
          </div>
          <div onClick={() => HandleClick(2)}>
            <p>Degustación</p>
            <span
              children={
                viewSondeo === 2 ? (
                  <KeyboardArrowRightIcon />
                ) : (
                  <KeyboardArrowLeftIcon />
                )
              }
            />
          </div>
          <div onClick={() => HandleClick(3)}>
            <p>Incidencias</p>
            <span
              children={
                viewSondeo === 3 ? (
                  <KeyboardArrowRightIcon />
                ) : (
                  <KeyboardArrowLeftIcon />
                )
              }
            />
          </div>
          <div onClick={() => HandleClick(4)}>
            <p>Ventas</p>
            <span
              children={
                viewSondeo === 4 ? (
                  <KeyboardArrowRightIcon />
                ) : (
                  <KeyboardArrowLeftIcon />
                )
              }
            />
          </div>

          {/* <div onClick={() => HandleClick(2)}>
                            <p>Ventas</p>
                            <span children={ viewSondeo === 2 ? <KeyboardArrowRightIcon/> :<KeyboardArrowLeftIcon/> }/>
                        </div> */}
          {/* <span onClick={() => HandleClick(5)}>Capacitación</span>   --------------SE CANCELA------- */}
        </ListMenu>
      </SubMenu>
      <Divider
        sx={{ backgroundColor: "#000000" }}
        orientation="vertical"
        variant="middle"
        flexItem
      />
      <ImgCity />
    </ContainerMenu>
  );
};

export default MenuClientes;
